import React from 'react';

import MogulIcon from '../../../common/images/mogul.png';
import SubmitIcon from '../../../common/images/submit-project.png';
import styles from './ProjectSubmissionPage.module.css';

interface Props {}

export const ProjectSubmissionHeader: React.FC<Props> = () => {
  // const onSubmit = () => {
  //   window.open(
  //     'https://powerforms.docusign.net/3d9da68c-de80-4614-9f94-8a0effd8c3d5?env=ca&acct=bec9678f-7b15-429b-8dd6-8286f3d64031&accountId=bec9678f-7b15-429b-8dd6-8286f3d64031',
  //     '_blank',
  //   );
  // };

  return (
    <div className="w-full text-center flex flex-row xl:px-32 px-4 py-12 h-auto justify-center bg-container bg-repeat bg-cover">
      <div className="flex flex-col space-y-8 lg:w-1/2">
        <h1 className={styles.heading}>SUBMIT PROJECT</h1>
      </div>
    </div>
  );
};
